export const environment = {
  defaultPageSize: 10,
  apiUrl: 'https://localhost:7291/api/',
  //apiUrl:'http://10.2.2.79:8060/api/',
  appUrl: 'https://localhost:4200/',
  attachmentMaxSize: 25, //mega
  skipCallingIAM:false,
  production: true
};

